// CubicMeterCalculator.js
import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedCubicMeterCalculator from "./SharedCubicMeterCalculator";
const TITLE = "Kalkulator Meter Kubik Elektronik - Pelajari Cara Menghitung Meter Kubik";
const DESCRIPTION =
  "Kalkulator meter kubik elektronik: Hitung volume dengan akurat untuk benda atau ruang apa pun dengan mudah! Pelajari cara menghitung meter kubik untuk kotak, ruangan, bahan, dan lainnya dengan contoh praktis.";
const KEYWORDS = "menghitung meter kubik";
const OG_URL = "https://do-calculate.com/calculator/id/cubicmeter";
function Calculator() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Meter kubik adalah satuan ukuran yang digunakan untuk menghitung kapasitas atau volume berbagai bentuk.
                Ada banyak bentuk geometris yang memerlukan rumus khusus untuk menghitung volumenya. Jika kita menganggap kubus dengan panjang 2 meter, lebar 2 meter, dan tinggi 2
                meter, kita dapat menggunakan rumus volume kubus yang dinyatakan sebagai panjang dikalikan lebar dikalikan tinggi. Ini berarti volume kubus akan menjadi 8 meter
                kubik.
                <br />
                Penggunaan meter kubik sebagai satuan standar membantu menyederhanakan proses perhitungan
                volume dan kapasitas untuk berbagai bentuk geometris.
                <br />
                <b>
                  Penggunaan meter kubik sebagai satuan standar membantu menyederhanakan proses perhitungan
                  volume dan kapasitas untuk berbagai bentuk geometris."
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedCubicMeterCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;